import { render, staticRenderFns } from "./MarkDayAsVerifiedButton.vue?vue&type=template&id=70e2c50a"
import script from "./MarkDayAsVerifiedButton.vue?vue&type=script&lang=js"
export * from "./MarkDayAsVerifiedButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports